import {
  Plane,
  Car,
  Bus,
  Building2,
  TrainFront,
  Palmtree,
  Ticket,
} from "lucide-react";

const services = [
  { icon: Plane, label: "Flights", copy: "Domestic & international, best fares" },
  { icon: Car, label: "Cabs", copy: "Airport transfers & city rides" },
  { icon: Bus, label: "Buses", copy: "Sleeper, AC & premium coaches" },
  { icon: Building2, label: "Hotels", copy: "From boutique to five-star" },
  { icon: TrainFront, label: "Trains", copy: "IRCTC tickets, made simple" },
  { icon: Palmtree, label: "Holidays", copy: "Curated leisure packages" },
  { icon: Ticket, label: "Events", copy: "Concerts, conferences & MICE" },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 sm:py-32 bg-white border-t border-[#4A1D96]/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14 reveal">
          <div className="max-w-2xl">
            <span className="uppercase tracking-[0.28em] text-xs text-[#F97316] font-semibold">
              What we book
            </span>
            <h2
              data-testid="services-heading"
              className="mt-4 font-serif text-4xl sm:text-5xl leading-[1.05] text-[#1B0F3A]"
            >
              One platform.
              <br />
              <span className="brand-gradient italic font-medium">Seven ways</span> to travel.
            </h2>
          </div>
          <p className="text-[#3B2A5B]/80 max-w-sm text-base">
            From a Mumbai board meeting to a Kerala honeymoon — every leg of
            the journey is booked, tracked and supported by one advisor.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 border-l border-t border-[#4A1D96]/10">
          {services.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.label}
                data-testid={`service-${s.label.toLowerCase()}`}
                className="group relative p-6 lg:p-7 border-r border-b border-[#4A1D96]/10 bg-white hover:bg-[#FFF8F1] transition-colors duration-500 reveal"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#F3EBFF] text-[#4A1D96] group-hover:bg-[#F97316] group-hover:text-white transition-colors">
                  <Icon size={22} strokeWidth={1.75} />
                </div>
                <h3 className="mt-5 font-serif text-xl text-[#1B0F3A]">{s.label}</h3>
                <p className="mt-2 text-[13px] leading-relaxed text-[#3B2A5B]/70">
                  {s.copy}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
